/**
 * A value that lags behind, so a keystroke is not a request.
 *
 * The volunteer picker searches the directory server-side: without this, typing
 * "Meghana" is seven round trips, six of which are already stale by the time
 * they land, and the one that matters queues behind them.
 *
 * 250ms is chosen to sit under the ~300ms at which a pause starts to feel like
 * waiting, while still collapsing an ordinary typing run into one request.
 */

import { useEffect, useState } from 'react';

export function useDebounced<T>(value: T, delay = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    // Cleared on every change, so the timer only fires once typing stops.
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
